// extracted by mini-css-extract-plugin
module.exports = {"ErrorPage":"ErrorPage_ErrorPage__kzh73","Logo":"ErrorPage_Logo__14mMG","Oops":"ErrorPage_Oops__2YwzU","ErrorText":"ErrorPage_ErrorText__2j8Dn","Box":"ErrorPage_Box__pFfuv"};